export const SET_BRAND_ID = 'setBrandId'
export const SET_URL = 'setUrl'
export const SET_SHOW_POWERED_BY = 'setShowPoweredBy'
export const SET_PRIMARY_COLOR = 'setPrimaryColor'
export const SET_SECONDARY_COLOR = 'setSecondaryColor'
export const SET_ICON_PRIMARY_COLOR = 'setIconPrimaryColor'
export const SET_ICON_SECONDARY_COLOR = 'setIconSecondaryColor'
export const SET_FONT_COLOR = 'setFontColor'
export const SET_IMAGES = 'setImages'
export const SET_BRAND_LOADING_STATUS = 'setBrandLoadingStatus'

const setBrandId = (state, payload) => {
    state.brandId = payload
}

const setUrl = (state, payload) => {
    state.url = payload
}

const setShowPoweredBy = (state, payload) => {
    state.showPoweredBy = payload
}

const setPrimaryColor = (state, payload) => {
    state.primaryColor = payload
}

const setSecondaryColor = (state, payload) => {
    state.secondaryColor = payload
}

const setIconPrimaryColor = (state, payload) => {
    state.primaryColor = payload
}

const setIconSecondaryColor = (state, payload) => {
    state.secondaryColor = payload
}

const setFontColor = (state, payload) => {
    state.fontColor = payload
}

const setImages = (state, payload) => {
    state.images = payload
}

const setBrandLoadingStatus = (state, payload) => {
    state.brandLoadingStatus = payload
}

export default {
    setBrandId,
    setUrl,
    setShowPoweredBy,
    setPrimaryColor,
    setSecondaryColor,
    setIconPrimaryColor,
    setIconSecondaryColor,
    setFontColor,
    setImages,
    setBrandLoadingStatus
}
